import React from 'react';
import autoBind from 'react-autobind';

import Localization from "composer/Localization.jsx";

import {
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  InputAdornment,
} from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

class ResetUserPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      newPassword: '',
      showPassword: false,
    };
    autoBind(this);
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  resetPasswordClicked() {
    if (this.validateInput()) {
      // Prepare the request object with necessary data
      const requestObj = {
        user_id: this.state.userId,
        new_password: this.state.newPassword,
      };
  
      // Call the API with the request object
      this.props.root.refs.API.request(
        "force_update_user_password",
        requestObj,
        this.resetPasswordOK,
        this.resetPasswordFailed
      );
    }
  }

    resetPasswordOK(response) {
        // Concatenate the message with the user ID
        const successMessage = "Password successfully reset for user ID: " + this.state.userId;
        this.props.root.addNotification(successMessage);
        // Additional logic as needed
    }

    resetPasswordFailed(error) {
        let errorMessage = "Failed to reset password";
    
        // Check if the error object is not empty
        if (error && typeof error === 'object' && Object.keys(error).length > 0) {
            // If there are details in the error object, append them
            errorMessage += ": " + JSON.stringify(error);
        } else {
            // Append a generic error message
            errorMessage += ". This could be due to network issues, the user ID not existing, or other server-side problems.";
        }
    
        this.props.root.addNotification(errorMessage);
        // Additional logic as needed
    }
       

    validateInput() {
        let result = true;
        let password = this.state.newPassword.trim();
        let illegalChars = /[\W_]/;
        let errorMessage = "";

        // password related
        if (illegalChars.test(password)) {
        result = false;
        errorMessage = Localization.strings.PASSWORD_REQUIREMENT_1;
        }
        else if (password.search(/[a-zA-Z]+/) == -1 || password.search(/[0-9]+/) == -1) {
        result = false
        errorMessage = Localization.strings.PASSWORD_REQUIREMENT_2;
        }
        else if (password.length < 6) {
        result = false;
        errorMessage = Localization.strings.PASSWORD_REQUIREMENT_3;
        }
        else if (password.length > 30) {
        result = false;
        errorMessage = Localization.strings.PASSWORD_REQUIREMENT_4;
        }

        // user id related
        const numericRegex = /^[0-9]+$/;
        if (!numericRegex.test(this.state.userId)) {
            errorMessage = "User ID must be numeric";
            result = false;
        }

        if (errorMessage != "") {
        this.props.root.addNotification(errorMessage);
        }

        return result;
    }

  togglePasswordVisibility() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  render() {
    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="User ID"
              value={this.state.userId}
              onChange={this.handleChange('userId')}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
                label="New Password"
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.newPassword}
                onChange={this.handleChange('newPassword')}
                fullWidth
                InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                        onClick={this.togglePasswordVisibility}
                        edge="end"
                        >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                    ),
                }}
                />
            </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.resetPasswordClicked}
            >
              {Localization.strings.RESET_PASSWORD} {/* Update your localization for this */}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default ResetUserPasswordForm;
